var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownArrow = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.51 9.66",
    ref: ref,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#878cac;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Arrow in case you need it") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,1.88A1.89,1.89,0,0,1,3.13.47L7.81,4.6,12.36.49a1.88,1.88,0,1,1,2.53,2.79l-7,6.38L.64,3.3A1.89,1.89,0,0,1,0,1.88Z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownArrow);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNS41MSA5LjY2Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6Izg3OGNhYzt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkFycm93IGluIGNhc2UgeW91IG5lZWQgaXQ8L3RpdGxlPjxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMCwxLjg4QTEuODksMS44OSwwLDAsMSwzLjEzLjQ3TDcuODEsNC42LDEyLjM2LjQ5YTEuODgsMS44OCwwLDEsMSwyLjUzLDIuNzlsLTcsNi4zOEwuNjQsMy4zQTEuODksMS44OSwwLDAsMSwwLDEuODhaIi8+PC9nPjwvZz48L3N2Zz4=";